__turbopack_context__.v({
  "footer": "Footer-module__EZoWya__footer",
  "footerBottom": "Footer-module__EZoWya__footerBottom",
  "footerCol": "Footer-module__EZoWya__footerCol",
  "footerGrid": "Footer-module__EZoWya__footerGrid",
  "footerGroup": "Footer-module__EZoWya__footerGroup",
  "footerGroupCols": "Footer-module__EZoWya__footerGroupCols",
  "footerInner": "Footer-module__EZoWya__footerInner",
  "footerSocial": "Footer-module__EZoWya__footerSocial",
});
